export const RESOURCE_DETAIL_PAGE_SIZE = 10

const RESOURCE_SOURCE_TYPE_TEXT_MAP = {
  1: '免费',
  2: '付费购入',
  3: '活动赠送',
  4: '预售赠送'
}

export function getResourceSourceTypeText(type) {
  return RESOURCE_SOURCE_TYPE_TEXT_MAP[Number(type)] || '-'
}

export function getResourceDetailList(result) {
  if (Array.isArray(result)) {
    return result
  }

  if (Array.isArray(result?.records)) {
    return result.records
  }

  if (Array.isArray(result?.list)) {
    return result.list
  }

  if (Array.isArray(result?.data)) {
    return result.data
  }

  return []
}

export function getResourceDetailPageData(result = {}) {
  return {
    records: getResourceDetailList(result),
    total: Number(result?.total) || 0,
    size: Number(result?.size) || RESOURCE_DETAIL_PAGE_SIZE,
    current: Number(result?.current) || 1
  }
}
